import React, { useState } from "react";

interface Logo {
  src: string;
  alt: string;
  isWide?: boolean;
  invertColors?: boolean;
  width?: string; // Optional specific width
  height?: string; // Added optional height
}

interface LogoShowcaseProps {
  logos: Logo[];
}

export const LogoShowcase: React.FC<LogoShowcaseProps> = ({ logos }) => {
  const [loadErrors, setLoadErrors] = useState<Record<string, boolean>>({});

  const handleImageError = (src: string) => {
    console.error(`Failed to load image: ${src}`);
    setLoadErrors((prev) => ({ ...prev, [src]: true }));
  };

  // Split logos into two rows: first 4 in row 1, remaining in row 2
  const firstRowLogos = logos.slice(0, 4);
  const secondRowLogos = logos.slice(4);

  return (
    <div className="flex flex-col items-center max-w-[1000px] mx-auto pointer-events-none">
      {/* First row - 4 logos */}
      <div className="grid grid-cols-4 justify-items-center max-md:grid-cols-2">
        {firstRowLogos.map((logo, index) => (
          <div
            key={index}
            className="flex items-center justify-center py-1 max-h-[6rem]"
          >
            {loadErrors[logo.src] ? (
              <div className="text-sm text-red-500">
                Failed to load {logo.alt}
              </div>
            ) : (
              <img
                src={logo.src}
                alt={logo.alt}
                className={`object-contain opacity-80 ${
                  logo.invertColors ? "brightness-0 invert" : ""
                }`}
                style={{
                  width: logo.width || "2.5rem",
                }}
                onError={() => handleImageError(logo.src)}
              />
            )}
          </div>
        ))}
      </div>

      {/* Second row - 2 logos */}
      <div className="grid grid-cols-2 justify-items-center">
        {secondRowLogos.map((logo, index) => (
          <div
            key={index}
            className="flex items-center justify-center py-1 max-h-[6rem]"
          >
            {loadErrors[logo.src] ? (
              <div className="text-sm text-red-500">
                Failed to load {logo.alt}
              </div>
            ) : (
              <img
                src={logo.src.split("#")[0]}
                alt={logo.alt}
                className={`object-contain opacity-80 ${
                  logo.invertColors ? "brightness-0 invert" : ""
                }`}
                style={{
                  width: logo.width || "2.5rem",
                }}
                onError={() => handleImageError(logo.src)}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
